export default "__VITE_ASSET__Co5jAX3s__"